import { Building2, Map } from "lucide-react";
import { OfficeManager } from "@/components/OfficeManager";

const WILAYAH = { kind: "wilayah", endpoint: "/wilayah", title: "Kantor Wilayah", headLabel: "Kepala Kantor Wilayah", icon: Map, placeholder: "cth. Wilayah Jawa Barat", subtitle: "Kelola kantor wilayah beserta akun kepala kantor wilayah." };
const CABANG = { kind: "cabang", endpoint: "/cabang", title: "Kantor Cabang", headLabel: "Kepala Kantor Cabang", icon: Building2, placeholder: "cth. Cabang Bandung Timur", subtitle: "Kelola kantor cabang di wilayah Anda beserta akun admin kantor cabang." };

export const WilayahPage = () => <OfficeManager cfg={WILAYAH} />;
export const CabangPage = () => <OfficeManager cfg={CABANG} />;
